import React, { useState, useRef } from 'react';
import { DataObjectContainer } from '../dataObjects/DataObjectContextManager';
import { BoundLabel } from '../dataObjects/BoundControls';
import { Card } from '../core/Card';
import { Download } from 'react-feather'; 

export const ApplicationInfo = ({ applicationKey, showUserInfo }) => {

    return (
        <DataObjectContainer dataObjectName={'applicationDataObject'} dataObjectId={applicationKey} >

            <table>
                <tbody>
                    <tr>
                        <td><h1><BoundLabel propertyName={'name'} /></h1></td>
                        <td><button className='btn btn-tertiary-outline pull-right mobile-hidden' onClick={() => { document.location = `/api/exchange/export/${applicationKey}` }}><Download className='icon' /><span className='text'>Export</span></button></td>
                    </tr>
                </tbody>
            </table>
            
            <Card title='General' subtitle='General information regarding this application'>
                <label>Client Id</label>
                <a href={`/applications/${applicationKey}`}><p><BoundLabel propertyName={'clientId'} /></p></a>

                <label>Default Culture Id</label>
                <p><BoundLabel propertyName={'defaultCultureId'} /></p>

                {showUserInfo &&
                    <div>
                        <label>Created By</label>
                        <p><BoundLabel propertyName={'createUser'} /></p>

                        <label>Date</label>
                        <p><BoundLabel propertyName={'createDate'} /></p>
                    </div>
                }
            </Card>

        </DataObjectContainer>
    );
}